import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Button } from '@lt/components';
import { Sizes } from '@lt/components/components/Button/Button';
import FeaturesList from '../FeaturesList';
import Certificate from '../Certificate';
import { MAIN_SECTION_ID } from '../../store/view/constants';
import { scrollToElement } from '../../../../utils/domUtils';
import Wrapper from './HeaderWrapper';
import withMobile from '../../hocs/withMobile';

const SUBHEADER_TEXT =
  'Порадуйте близких возможностью отправиться в отпуск в ту страну, которую они выберут сами в удобные для них даты.';

const scrollToMainSection = () =>
  scrollToElement(document.getElementById(MAIN_SECTION_ID));

const Header = ({ isMobile }) => (
  <Wrapper>
    <StyledHeader isMobile={isMobile}>
      Подарочный
      {isMobile ? ' ' : String.fromCharCode(160)}
      сертификат на&nbsp;путешествие
    </StyledHeader>
    <StyledSubHeader isMobile={isMobile}>{SUBHEADER_TEXT}</StyledSubHeader>
    <StyledButton isMobile={isMobile} onClick={scrollToMainSection}>
      Выбрать сертификат
    </StyledButton>
    <StyledCertificate width={isMobile ? 127 : 260} />
    <FeaturesList />
  </Wrapper>
);

const StyledHeader = styled.h1`
  margin-top: 50px;
  margin-bottom: 15px;
  max-width: 770px;
  font-size: 64px;
  line-height: 1;
  font-weight: bold;
  text-align: center;
  color: ${(props) => props.theme.colors.white};

  ${(props) =>
    props.isMobile &&
    css`
      margin-top: 20px;
      margin-bottom: 10px;
      max-width: 210px;
      font-size: 28px;
      line-height: 1.07;
    `};
`;

const StyledCertificate = styled(Certificate)`
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
`;

const StyledButton = styled(Button).attrs({
  primary: true,
  size: Sizes.FLEX,
})`
  margin: 33px 0;
  padding: 7px 25px;
  font-size: 14px;

  ${(props) =>
    props.isMobile &&
    css`
      margin: 25px 0;
      padding: 7px 45px;
      height: 50px;
    `};
`;

const StyledSubHeader = styled.p`
  max-width: 500px;
  font-size: 22px;
  line-height: 1.45;
  text-align: center;
  color: ${(props) => props.theme.colors.white};

  ${(props) =>
    props.isMobile &&
    css`
      max-width: 225px;
      font-size: 13px;
      line-height: 1.14;
    `};
`;

Header.propTypes = {
  isMobile: PropTypes.bool,
};
Header.defaultProps = {
  isMobile: false,
};

export default React.memo(withMobile(Header));
